import React, { useEffect, useRef, useState } from "react"
import { copiarAlPortapapeles, cuitSinGuiones } from "helpers/clipboard_helpers"

const DURACION_FEEDBACK_MS = 1500

/**
 * BDSJEA-406: boton "copiar" para ir junto a un CUIT mostrado con guiones.
 * Copia el CUIT SIN guiones y muestra un feedback breve: un tilde si se
 * copio, o una cruz si el navegador no lo permitio (en ese caso el CUIT sigue
 * visible para copiarlo a mano). No renderiza nada si no hay digitos.
 */
const BotonCopiarCuit = ({ cuit, className = "" }) => {
  const [estado, setEstado] = useState(null) // null | "ok" | "error"
  const temporizador = useRef(null)
  const montado = useRef(true)

  useEffect(
    () => () => {
      montado.current = false
      clearTimeout(temporizador.current)
    },
    [],
  )

  const digitos = cuitSinGuiones(cuit)
  if (!digitos) return null

  const copiar = async () => {
    const copiado = await copiarAlPortapapeles(digitos)
    if (!montado.current) return
    setEstado(copiado ? "ok" : "error")
    clearTimeout(temporizador.current)
    // Se cancela al desmontar (useEffect de arriba): no hace falta guarda.
    temporizador.current = setTimeout(
      () => setEstado(null),
      DURACION_FEEDBACK_MS,
    )
  }

  const titulo =
    estado === "ok"
      ? "CUIT copiado"
      : estado === "error"
        ? "No se pudo copiar: seleccionalo y copialo a mano"
        : "Copiar CUIT sin guiones"
  const icono =
    estado === "ok"
      ? "mdi-check text-success"
      : estado === "error"
        ? "mdi-close text-danger"
        : "mdi-content-copy"

  return (
    <>
      <button
        type="button"
        className={`btn btn-link btn-sm p-0 ms-1 align-baseline ${className}`.trim()}
        title={titulo}
        aria-label={titulo}
        data-testid="boton-copiar-cuit"
        onClick={copiar}
      >
        <i className={`mdi ${icono}`} aria-hidden="true" />
      </button>
      {/* Region viva: anuncia el resultado a lector de pantalla (BDSJEA-406). */}
      <span role="status" aria-live="polite" className="visually-hidden">
        {estado ? titulo : ""}
      </span>
    </>
  )
}

export default BotonCopiarCuit
